import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { COLORS } from '../../styles/colors';
import { largerClickableArea } from '../../styles/mixins';
import { ButtonType } from '../button/WxButton';

type LinkProps = {
  href?: string;
  target?: string;
  onClick?: () => void;
  type?: ButtonType;
  children: React.ReactNode;
  darkMode?: boolean;
};

const WxLink = ({
  href = '',
  target = '_self',
  children,
  onClick,
  type,
  darkMode = false,
}: LinkProps) => {
  if (href === '' && onClick)
    return (
      <ButtonLink
        darkMode={darkMode}
        onClick={type === 'disabled' ? undefined : onClick}
        data-type={type}
      >
        {children}
      </ButtonLink>
    );

  const internal = href?.startsWith('/');

  return (
    <Container>
      {internal ? (
        <RouterLink
          darkMode={darkMode}
          to={type === 'disabled' ? '' : href}
          target={target}
          data-type={type}
          onClick={onClick}
        >
          {children}
        </RouterLink>
      ) : (
        <RouterLink
          darkMode={darkMode}
          to={type === 'disabled' ? '' : href}
          target={target ?? '_blank'}
          data-type={type}
          onClick={onClick}
        >
          {children}
        </RouterLink>
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: fit-content;
`;

const linkStyle = (darkMode: boolean) => css<{ darkMode: boolean }>`
  color: var(--color, ${COLORS.black});

  font-weight: 900;
  text-decoration: none;

  &[data-type]:not([data-type='disabled']) {
    cursor: pointer;
  }

  &[data-type='validation'] {
    --color: ${COLORS.green};
  }

  &[data-type='disabled'] {
    --color: ${COLORS.darkgray};
    cursor: default;
  }

  &[data-type='alert'] {
    --color: ${COLORS.red};
  }

  &[data-type='neutral'] {
    --color: ${(props: any) => (props.darkMode ? COLORS.white : COLORS.black)};
  }
`;

const RouterLink = styled(Link)<{ darkMode: boolean }>`
  ${(props) => linkStyle(props.darkMode)}
  ${largerClickableArea(1.5)}
`;

const ButtonLink = styled.div<{ darkMode: boolean }>`
  ${(props) => linkStyle(props.darkMode)}

  text-transform: uppercase;
`;

export default WxLink;
